import { render, staticRenderFns } from "./PreparationTime.vue?vue&type=template&id=23d45f29&scoped=true"
import script from "./PreparationTime.vue?vue&type=script&lang=js"
export * from "./PreparationTime.vue?vue&type=script&lang=js"
import style0 from "./PreparationTime.vue?vue&type=style&index=0&id=23d45f29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d45f29",
  null
  
)

export default component.exports